import React, { FC, useState } from 'react';

import cx from 'classnames';
import { isNil, range } from 'ramda';

import Star from 'components/shared/Icon/icons/Star';

import styles from './index.module.css';
import { IRateInputProps } from './types';

const RateInput: FC<IRateInputProps> = ({
  length = 5,
  value = 0,
  starIndent = 0,
  starSize = 30,
  onChange,
  readOnly,
}) => {
  const [hoveredRate, setHoveredRate] = useState<number | null>(null);
  const isHovered = !isNil(hoveredRate);

  return (
    <div className={cx(styles.container, readOnly && styles.containerReadOnly)}>
      {range(1, length + 1).map((itemRate, idx, array) => (
        <button
          key={itemRate}
          type="button"
          onMouseEnter={() => setHoveredRate(itemRate)}
          onMouseLeave={() => setHoveredRate(null)}
          onClick={() => {
            onChange(itemRate);
          }}
          className={styles.star}
          style={{ paddingRight: array.length - 1 === idx ? 0 : starIndent }}
          disabled={readOnly}
        >
          <Star size={starSize} filled={(isHovered && itemRate <= hoveredRate) || (!isHovered && itemRate <= value)} />
        </button>
      ))}
    </div>
  );
};

export default RateInput;
